
import React, { useState ,useEffect} from 'react';
import {useNavigate } from 'react-router-dom';
import {Row,Col, Table,Button,Form,Select,Input,Flex,notification,Space, DatePicker, message,Typography, Checkbox} from 'antd';
import Title from 'antd/es/skeleton/Title';
import { viewAdminDistributed,getSalesUsers, distributeLeads ,viewSurveySearch,viewSearchQuery,masterSource} from '../service/UserDetails';
import { render } from '@testing-library/react';
import Item from 'antd/es/list/Item';
import App from '../App';
import './design.css';
import { Divider } from 'antd';
import moment from 'moment';
import { MinusCircleOutlined, PlusOutlined, SearchOutlined, DeleteOutlined } from '@ant-design/icons';
import axios from "axios";

const { Option } = Select;
const { RangePicker } = DatePicker;

const fieldOptions = [
    { label: 'Lead Id', value: 'id', dataType: 'text' },
    { label: 'Lead Date', value: 'created_at', dataType: 'date' },
    { label: 'Survey Agent Name', value: 'agent_name', dataType: 'text' },
    { label: 'Quality Agent Name', value: 'quality_agent_name', dataType: 'text' },
    { label: 'Sales Agent Name', value: 'sales_agent_name', dataType: 'text' },
    { label: 'Distribution Date', value: 'distributed_on', dataType: 'date' },
    { label: 'Business Name', value: 'business_name', dataType: 'text' },
    { label: 'Customer Name', value: 'customer_name', dataType: 'text' },
    { label: 'Billing Address', value: 'billing_address', dataType: 'text' },
    { label: 'Billing Postcode', value: 'billing_postcode', dataType: 'text' },
    { label: 'Contact Number', value: 'contact_number', dataType: 'text' },
    { label: 'Email Address', value: 'email_address', dataType: 'text' },
    { label: 'Product', value: 'product_id', dataType: 'text' },
    { label: 'Electricity Current Supplier', value: 'elec_current_supplier', dataType: 'dropdown' },
    { label: 'Gas Current Supplier', value: 'gas_current_supplier', dataType: 'text' },
    { label: 'Gas Account Number', value: 'gas_account_number', dataType: 'text' },
    { label: 'Electric Account Number', value: 'elec_account_number', dataType: 'text' },
    { label: 'Supply Number', value: 'supply_number', dataType: 'text' },
    { label: 'MPR Number', value: 'gas_mpr', dataType: 'text' },
    { label: 'Electric MSN', value: 'elec_msn', dataType: 'text' },
    { label: 'Gas MSN', value: 'gas_msn', dataType: 'text' },
    { label: 'Electric Contract End Date', value: 'elec_contract_end_date', dataType: 'date' },
    { label: 'Gas Contract End Date', value: 'gas_contract_end_date', dataType: 'date' },
    { label: 'Electric EAC', value: 'elec_eac', dataType: 'number' },
    { label: 'Gas EAC', value: 'gas_eac', dataType: 'number' },
    { label: 'Gas Billing Amount', value: 'gas_billing_amount', dataType: 'number' },
    { label: 'Electric Billing Amount', value: 'elec_billing_amount', dataType: 'number' },
    { label: 'Gas Meter Type', value: 'gas_metertype', dataType: 'text' },
    { label: 'Electricity Meter Type', value: 'elec_metertype', dataType: 'text' },
    { label: 'Gas Standing Charge', value: 'gas_standing_charge', dataType: 'text' },
    { label: 'Electric Standing Charge', value: 'elec_standing_charge', dataType: 'text' },
    { label: 'Gas Unit Rate', value: 'gas_unit_rate', dataType: 'text' },
    { label: 'Electric Unit Rate', value: 'elec_unit_rate', dataType: 'text' },
    { label: 'Night Rate', value: 'night_rate', dataType: 'text' },
    { label: 'Eve Weekend', value: 'eve_weekend', dataType: 'text' },
    { label: 'Capacity Charge', value: 'capacity_charge', dataType: 'text' },
    { label: 'FIT Charge', value: 'elec_fit_charge', dataType: 'text' },
    { label: 'Lead Status', value: 'lead_status_list_id', dataType: 'text' },
    { label: 'Sales Lead Status', value: 'sales_status_list_id', dataType: 'text' },
    
    { label: 'Call Back Date', value: 'callback_date', dataType: 'date' },
    { label: 'Survey Feedback', value: 'survey_feedback', dataType: 'text' },
    { label: 'Quality Feedback', value: 'quality_feedback', dataType: 'text' },
    { label: 'Sales Feedback', value: 'sales_feedback', dataType: 'text' }
  ];
function DistributedLead(){
    const navigator = useNavigate();

    const [inputNumber, setInputNumber] = useState();
    const [salesAgentId, setSalesAgentId] = useState(null);
    const [selectedValue, setSelectedValue] = useState(undefined);

    
  const [filteredDataSource, setFilteredDataSource] = useState([]);
  const [fields, setFields] = useState([]);
  const [selectedField, setSelectedField] = useState('');
  const [productSupplierOptions, setProductSupplierOptions] = useState([]);
  const [showElecCurrentSupplierDropdown, setShowElecCurrentSupplierDropdown] = useState(false);
  const [showGasCurrentSupplierDropdown, setShowGasCurrentSupplierDropdown] = useState(false);
  const [showGasMeterTypeDropdown, setShowGasMeterTypeDropdown] = useState(false);
  const [showElecMeterTypeDropdown, setShowElecMeterTypeDropdown] = useState(false);
  const [showLeadStatusDropdown, setShowLeadStatusDropdown] = useState(false);
  const [showSalesStatusDropdown, setShowSalesStatusDropdown] = useState(false);
  

  const [showProductDropdown, setShowProductDropdown] = useState(false);
  const [gasCurrentSupplierOptions , setCurrentSupplierGas] = useState([]);
  const [elecCurrentSupplierOptions , setCurrentSupplierElectricity] = useState([]);
  const [leadStatusTypes, setLeadStatusTypes] = useState(new Set());
  const [leadStatusArray, setLeadStatusArray] = useState([]);
  const [elecMeterTypeOptions , setMeterTypeOptionElect] = useState([]);
  const [gasMeterTypeOptions , setMeterTypeOptionGas] = useState([]);
  const [leadStatusOptions , setLeadStatusOptions] = useState([]);
  const [salesStatusOptions , setSalesStatusOptions] = useState([]);
  const [totalNoOfRecords , setTotalNoOfRecords] = useState('');
  const [excludeDistributed, setExcludeDistributed] = useState(true);

  const handleAddField = (value) => {
    if (value) {
      const selectedOption = fieldOptions.find(option => option.value === value);
      // const newField = {
      //   name: selectedOption.value,
      //   operator: selectedOption.dataType === 'date' ? 'from to' : 'exact',
      //   value: selectedOption.dataType === 'date' ? [null, null] : '',
      //   dataType: selectedOption.dataType,
      // };
       // Create a new field object based on the selected option
       const newField = {
        name: selectedOption.value,
        operator: selectedOption.dataType === 'date' || selectedOption.dataType === 'number' ? 'range' : 'exact', // Default to 'range' for date and number
        value: selectedOption.dataType === 'date' ? [null, null] : (selectedOption.dataType === 'number' ? [null, null] : ''), // Default range to [null, null] for date and number
        dataType: selectedOption.dataType,
      };
      setFields([...fields, newField]);
      setSelectedField('');
    //  handleSearch([...fields, newField]); // Update filtered data when a new field is added

    if (value === 'product_id') {
      setShowProductDropdown(true);
      newField.dataType = 'select';
    } else if (value === 'elec_current_supplier') {
      setShowElecCurrentSupplierDropdown(true);
      newField.dataType = 'select';
    } else if (value === 'gas_current_supplier') {
      setShowGasCurrentSupplierDropdown(true);
      newField.dataType = 'select';
    } else if (value === 'gas_metertype') {
      setShowGasMeterTypeDropdown(true);
      newField.dataType = 'select';
    } else if (value === 'elec_metertype') {
      setShowElecMeterTypeDropdown(true);
      newField.dataType = 'select';
    }else if (value === 'lead_status_list_id') {
      setShowLeadStatusDropdown(true);
      newField.dataType = 'select';
    }
    else if (value === 'sales_status_list_id') {
      setShowSalesStatusDropdown(true);
      newField.dataType = 'select';
    }
    
    }
   
    setSelectedValue('Select a field');
  };

  const handleRemoveField = (index) => {
    const newFields = fields.filter((_, i) => i !== index);
    setFields(newFields);
  //  handleSearch(newFields); // Update filtered data when a field is removed
  // Hide product dropdown if there are no more product fields
  if (newFields.every(field => field.name !== 'product_id')) {
    setShowProductDropdown(false);
  }

  if (newFields.every(field => field.name !== 'elec_current_supplier')) {
    setShowElecCurrentSupplierDropdown(false);
  }

  if (newFields.every(field => field.name !== 'gas_current_supplier')) {
    setShowGasCurrentSupplierDropdown(false);
  }

  if (newFields.every(field => field.name !== 'gas_metertype')) {
    setShowGasMeterTypeDropdown(false);
  }

  if (newFields.every(field => field.name !== 'elec_metertype')) {
    setShowElecMeterTypeDropdown(false);
  }

  if (newFields.every(field => field.name !== 'lead_status_list_id')) {
    setShowLeadStatusDropdown(false);
  }

  if (newFields.every(field => field.name !== 'sales_status_list_id')) {
    setShowSalesStatusDropdown(false);
  }

  
  };

  const handleFieldChange = (index, key, value) => {
    const newFields = [...fields];
    newFields[index][key] = value;
    setFields(newFields);
    //handleSearch(newFields); // Update filtered data when a field is changed
  };

      const handleSearch = async () => {
        try {
           //  const sqlQuery = buildSQLQuery(fields);
   //   const sqlQuery = buildJSONFilters(fields);
   const jsonFilters = buildJSONFilters(fields);
   

     
   //  
    // const encodedQuery = encodeURIComponent(JSON.stringify(jsonFilters));
     const encodedQuery = JSON.stringify(jsonFilters.filters);
     
          try {
            const res = await viewSearchQuery(encodedQuery, excludeDistributed);
            
            const mappedData = res.data.data;
            
            let records = mappedData.map((d) => ({ ...d, key: d.id }));

            setTotalNoOfRecords(mappedData.length);
            
           // setDataSource(records);
            setFilteredDataSource(records); // Initialize filteredDataSource
          // setDataSource(mappedData);
         //   setFilteredDataSource(mappedData); // Initialize filteredDataSource
            
          } catch (err) {
            
            if (err.response.data.error === "No leads found with the provided filters") {
              message.error("No leads found with the provided filters");
            }
          }
          
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      };

      const buildJSONFilters = (fields) => {
        return {
          filters: fields.map(field => {
            const { name, operator, value, dataType } = field;
            
            if (dataType === 'date' && operator === 'range') {
              return {
                column: name,
                operator: 'BETWEEN',
                values: value
              };
            } else if (dataType === 'number' && operator === 'range') {
              return {
                column: name,
                operator: 'BETWEEN',
                values: value
              };
            } else if (dataType === 'text') {
              let formattedValue = value;
              if (operator === 'like') {
                return {
                  column: name,
                  operator: 'LIKE',
                  value: formattedValue
                };
              } else if (operator === 'unlike') {
                return {
                  column: name,
                  operator: 'NOT LIKE',
                  value: formattedValue
                };
              } else {
                return {
                  column: name,
                  operator: '=',
                  value: formattedValue
                };
              }
            } else if (dataType === 'select') {
              return {
                column: name,
                operator: '=',
                value: value
              };
            } else if (dataType === 'number') {
              return {
                column: name,
                operator: operator,
                value: value
              };
            }
            return null;
          }).filter(filter => filter !== null)
        };
      };

  // const buildSQLQuery = (fields) => {
  //   const sqlConditions = fields.map(field => {
  //     const { name, operator, value, dataType } = field;
      
  //     if (dataType === 'date' && operator === 'from to') {
  //       return `${name} BETWEEN '${value[0]}' AND '${value[1]}'`;
  //     }  else if (dataType === 'text') {
  //       let formattedValue = value;
  //       if (operator === 'like') {
  //         formattedValue = `${value}`;
  //         return `${name} LIKE '${formattedValue}'`;
  //       } else if (operator === 'unlike') {
  //         formattedValue = `${value}`;
  //         return `${name} NOT LIKE '${formattedValue}'`;
  //       } else {
  //         return `${name} = '${formattedValue}'`;
  //       }
  //     } else if (dataType === 'number') {
  //       return `${name} ${operator} ${value}`;
  //     }else if (dataType === 'select') {
  //       // Dropdown selection query
  //       // Assuming value is a single value for select type fields
  //       return `${name} = '${value}'`;
  //     }
  //     return '';
  //   }).filter(condition => condition).join(' AND ');
  
  //   return `${sqlConditions}`;
  // };
    const onChangeSelect = (value) => {
      setSalesAgentId(value);  // Set the selected sales agent ID
      
    };
    const onSearch = (value) => {
      
    };

    const addedFieldNames = fields.map(field => field.name);

    const handleDistribute = async () => {
      if (!salesAgentId || selectedRowKeys.length === 0) {
          notification.error({
              message: 'Error',
              description: 'Please select a sales agent and at least one lead to distribute.',
          });
          return;
      }

      const leads_ids = selectedRowKeys;
      const filter = "unDistributedLeads";
      const idsString = leads_ids.join(',');
      const payload = {
          "sales_agent_id": salesAgentId,
          "leads_ids": idsString,
          "filter": filter,
      };

      try {
          const res = await distributeLeads(payload);
          if (res.status === 200) {
              notification.success({ message: "Successfully distributed!" });
              

               // Refresh the table data after successful distribution
            await callBackResponse();
            
            // Clear the selected rows
            setSelect({ selectedRowKeys: [], loading: false });
          }
      } catch (error) {
          
          notification.error({ message: "Error distributing leads." });
      }
  };
//     const handleDistribute = async e => {
//       // e.preventDefault();
    
//       const sales_agent_id = "20";
//       const leads_ids = selectedRowKeys;
//       
//       const filter ="unDistributedLeads";

//   const idsString = leads_ids.join(',');
//   const leadsIdsString = `${idsString}`;
//   
//   const payload = {
//     "sales_agent_id": sales_agent_id,
//     "leads_ids": leadsIdsString,
//     "filter": filter

// };

//   // Output: "leads_ids": "1,2,3,4"
      
//       const user = {sales_agent_id,leadsIdsString}
//       
//        await distributeLeads(payload
//        ).then((res) => {
//            
//            if(res.status === 200)
//            {
//                   // setMessage("Please enter correct credentials");
//                   notification.success({message:"Sucessfully distributed !"});
//                   }
            
   
//        })
//        .catch(error => {
//            
           
//          })
       
//      }
    const handleClick = event=>{
        
        navigator('/admin-lead-home',{state:{findUser: event, isEdit: true  }});

    }

    const layout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };

    // const loadMasterData = async () => {
    //     const response =await masterSource();
    //     const meterOpt = [];
    //     response.data.meter_types.map(item=>  meterOpt.push({label: item.meter_type,value: item.id}))
    //     setMeterTypeOption(meterOpt);
        
    //  }
const [dataSource, setDataSource]= useState([]) 

const [salesUsersName , setSalesUsersName] = useState([]);
  const loadUsersData = async () => {
  
    const response =await getSalesUsers();
    const dataList = response.data.data;
    const dataListForNames = [];

    dataList.forEach(element => {
      dataListForNames.push({label: element.attributes.name,value:element.id})
     // dataListForNames.push(element.attributes.name)
    });
    
    
    setSalesUsersName(dataListForNames);
}
  

const callBackResponse = async () => {
  try {

   // const response = await viewAdminDistributed();
  //  const mappedData = response.data.data;
    //let records = mappedData.map((d) => ({ ...d, key: d.id }));
   // 
  //  setDataSource(records);
    const res = await viewAdminDistributed();
    
    const mappedData = res.data.data;
    
    let records = mappedData.map((d) => ({ ...d, key: d.id }));
    
   // setDataSource(records);
    setFilteredDataSource(records); // Initialize filteredDataSource

    // Fetch product supplier options
    const response = await masterSource();
    const meterOptGas = [];
    const meterOptElec = [];
    const productsSupplier = [];
    const currentSupplierGas = [];
    const currentSupplierElectricity = [];
    const leadStatus = [];
    const salesStatus = [];
    
    //response.data.suppliers.map(item=> currentSupplier.push({label: item.supplier_name,value: item.id}))
    response.data.products.map(item=> productsSupplier.push({label: item.product_name,value: item.id}))
    response.data.meter_types.map(item=> {
     if(item.product_id === 1){
     meterOptElec.push({label: item.meter_type,value: item.id})
    }else if(item.product_id === 2){
     meterOptGas.push({label: item.meter_type,value: item.id})
    } })
    response.data.lead_statuses.map(item=> leadStatus.push({label:item.status,value: item.id}))
    response.data.sales_statuses.map(item=> salesStatus.push({label:item.status,value: item.id}))


    response.data.suppliers.map(item=> {
     if(item.product_id === 1){
       currentSupplierElectricity.push({label: item.supplier_name,value: item.id})
       
    }else if(item.product_id === 2){
     currentSupplierGas.push({label: item.supplier_name,value: item.id})
    } 
    }
    )
    setMeterTypeOptionElect(meterOptElec);
    setMeterTypeOptionGas(meterOptGas);
    setProductSupplierOptions(productsSupplier);
    setCurrentSupplierGas(currentSupplierGas);
    setCurrentSupplierElectricity(currentSupplierElectricity);
    setLeadStatusOptions(leadStatus)
    setSalesStatusOptions(salesStatus)
    
  } catch (err) {
    
    if (err.response.data.error === "No leads found with the provided filters") {
      
    }
  }
   


} 

useEffect(()=>{

    callBackResponse();
    loadUsersData();

  },[]);

  const columns =[
    {
        key:'id',
        title : 'Lead ID',
        dataIndex : 'id',
        width: 100,
        render:id => id ,
    },
    {
       // key:'lead_date',
        title : 'Lead Date',
       // dataIndex : 'lead_date',
       render: (record) => { return (<p>{moment.utc(record.attributes.created_at).format("DD-MM-YYYY")}</p>)},
      // render: (record) => record.attributes.created_at,
        width: 150
    },
    {
      title : 'Survey Agent Name',
      width: 150,
      render: (record) => record.attributes.agent_name
   },
    {
      title : 'Quality Agent Name',
      width: 150,
      render: (record) => record.attributes.quality_agent_name
  }, 
  {
      title : 'Sales Agent Name',
      width: 150,
      render: (record) => record.attributes.sales_agent_name
  }, 
  {
    title : 'Distribution Date',
    width: 150,
    render: (record) => { return (<p>{record.attributes.distributed_on ? moment(record.attributes.distributed_on).format("DD-MM-YYYY"): ""}</p>)},
    
  },
    {
      //  key: 'attributes.business_name',
        title : 'Business Name',
       // dataIndex :'attributes.business_name',
        width: 150,
        render: (record) => record.attributes.business_name
        //render: business_name => business_name,
    },
    {
      //  key:'customer_name',
        title : 'Customer Name',
        //dataIndex : 'customer_name',
        render: (record) => record.attributes.customer_name,
        width: 150
    },
    {
       // key:'billing_address',
        title : 'Billing Address',
      //  dataIndex : 'billing_address',
      render: (record) => record.attributes.billing_address,
        width: 150,
    },
    {
      //  key:'billing_postcode',
        title : 'Billing Postcode',
        render: (record) => record.attributes.billing_postcode,
      //  dataIndex : 'billing_postcode',
        width: 150,
    },
    {
       // key:'contact_number',
        title : 'Contact Number',
        render: (record) => record.attributes.contact_number,
      //  dataIndex : 'contact_number',
        width: 150,
    },
    {
       // key:'email_address',
        title : 'Email Address',
        render: (record) => record.attributes.email_address,
       // dataIndex : 'email_address',
        width: 150,
    },
    {
       // key:'product_id',
        title : 'Product',
       // dataIndex : 'product_id', 
       render:(record) => {
        // Check the product_id and return the corresponding text
        return record.attributes.product_id === 1 ? "Electricity" : "Gas";
      },
       //render: (record) => {if(record.attributes.product_id ===1){"Electricity"}else{"Gas"}},
        width: 150
    },
    {
        //key:'elec_current_supplier',
        title : 'Elec Current Supplier',
     //   dataIndex : 'elec_current_supplier',
        render: (record) => record.relations.supplier.electricity.name,
        width: 150
    },
    {
      // key:'elec_account_number',
       title : 'Elec Account Number',
       render: (record) => record.attributes.electricity.account_number,
       //dataIndex : 'elec_account_number',
       width: 150
   },
   {
    // key:'elec_supply_number',
     title : 'Supply Number',
    // dataIndex : 'elec_supply_number',
    render: (record) => {
     if(record.attributes.electricity.supply_number){
     const supplyNumber = record.attributes.electricity.supply_number;

     // Assuming supplyNumber is a string of 21 characters (8 + 13)
     const formattedSupplyNumber = `${supplyNumber.slice(0, 8)} ${supplyNumber.slice(8)}`;

     return formattedSupplyNumber;
   }
   },
     width: 170
 },
 {
  //  key:'elec_msn',

    title : 'Electric MSN',
    render: (record) => record.attributes.electricity.msn,
    width: 150
   // dataIndex : 'elec_msn'
},
{
  //key:'elec_contract_end_date',
  title : 'Electric Contract End Date',
  render: (record) => record.attributes.electricity.contract_end_date,
 // dataIndex : 'elec_contract_end_date',
  width: 150
},
{
  //key:'elec_eac',
  title : 'Electric EAC',
  render: (record) => record.attributes.electricity.eac,
  //dataIndex : 'elec_eac',
  width: 150
},
{
  //key:'gas_billing_amount',
  title : 'Electric Billing Amount',
  render: (record) => record.attributes.electricity.billing_amount,
 // dataIndex : 'elec_billing_amount',
  width: 150
},
{
//key:'gas_billing_amount',
title : 'Electric Billing Frequncy',
render: (record) => record.attributes.electricity.billing_frequency,
// dataIndex : 'elec_billing_amount',
width: 150
},
{
  //key:'gas_metertype',
  title : 'Electricity Meter type',
  //dataIndex : 'gas_metertype',
 render: (record) => record.relations.meter_type.electricity.name,
  width: 150
},
{
  //key:'gas_standing_charge',
  title : 'Electric Standing Charge',
  render: (record) => record.attributes.electricity.standing_charge,
 // dataIndex : 'gas_standing_charge',
  width: 150
},

{
  // key:'gas_unit_rate',
   title : 'Electric Unit Rate',
   render: (record) => record.attributes.electricity.unit_rate,
   //dataIndex : 'gas_unit_rate',
   width: 150
},
{
 // key:'elec_night_rate',
  title : 'Night Rate',
  render: (record) => record.attributes.electricity.night_rate,
  //dataIndex : 'elec_night_rate',
  width: 150
},
{
  //key:'elec_eve_weekend',
  title : 'Eve Weekend',
  render: (record) => record.attributes.electricity.eve_weekend,
  //dataIndex : 'elec_eve_weekend',
  width: 150
},
{
//  key:'elec_capacity_charge',
  title : 'Capacity Charge',
  render: (record) => record.attributes.electricity.capacity_charge,
//  dataIndex : 'elec_capacity_charge',
  width: 150
},
{
//  key:'elec_fit_charge',
  title : 'FIT Charge',
  render: (record) => record.attributes.electricity.fit_charge,
 // dataIndex : 'elec_fit_charge',
  width: 150
},
    {
        //key:'elec_current_supplier',
        title : 'Gas Current Supplier',
     //   dataIndex : 'elec_current_supplier',
        render: (record) => record.relations.supplier.gas.name,
        width: 150
    },
    {
        // key:'elec_account_number',
         title : 'Gas Account Number',
         render: (record) => record.attributes.gas.account_number,
         //dataIndex : 'elec_account_number',
         width: 150
     },
   
    
    {
      //  key:'gas_mpr',
        title : 'MPR Number',
        render: (record) => record.attributes.gas.mpr,
        //dataIndex : 'gas_mpr',
        width: 150
    },
    
    {
      //  key:'gas_msn',
        title : 'Gas MSN',
        render: (record) => record.attributes.gas.msn,
      //  dataIndex : 'gas_msn',
        width: 150
    },
    
    {
      //  key:'gas_contract_end_date',
        title : 'Gas Contract End Date',
        render: (record) => record.attributes.gas.contract_end_date,
      //  dataIndex : 'gas_contract_end_date',
        width: 150
    },
    
    {
        //key:'gas_eac',
        title : 'Gas EAC',
        render: (record) => record.attributes.gas.eac,
        //dataIndex : 'gas_eac',
        width: 150
    },
      
  {
   // key:'gas_billing_amount',
    title : 'Gas Billing Amount',
  //  dataIndex : 'gas_billing_amount',
  render: (record) => record.attributes.gas.billing_amount,
    width: 150
},

{
    //key:'gas_metertype',
    title : 'Gas Meter type',
    //dataIndex : 'gas_metertype',
    render: (record) => record.relations.meter_type.gas.name,
    width: 150
},

{
    //key:'gas_standing_charge',
    title : 'Gas Standing Charge',
    render: (record) => record.attributes.gas.standing_charge,
   // dataIndex : 'gas_standing_charge',
    width: 150
},

{
   // key:'gas_unit_rate',
    title : 'Gas Unit Rate',
    render: (record) => record.attributes.gas.unit_rate,
    //dataIndex : 'gas_unit_rate',
    width: 150
},
{
  //  key:'lead_status_list_id',
    title : 'Lead Status',
    render: (record) => record.relations.lead_status.name,
 //   dataIndex : 'lead_status_list_id',
    width: 150
},
{
  //  key:'lead_status_list_id',
    title : 'Sales Lead Status',
    render: (record) => record.relations.sales_status.name,
 //   dataIndex : 'lead_status_list_id',
    width: 150
},
{
  //  key:'lead_status_list_id',
    title : 'Call Back Date',
    render: (record) => { return (<p>{record.attributes.callback_date?moment(record.attributes.callback_date).format("DD-MM-YYYY"):""}</p>)},
 //   dataIndex : 'lead_status_list_id',
    width: 150
},

// {
//     //key:'agent_feedback',
//     title : 'Agent Feedback',
//     dataIndex : (record) => record.attributes.lead_status_list_id,
//     width: 150
// }
// {
//   title: 'Agent Feedback',
//   key: 'agent_feedback',
//   dataIndex: 'attributes', // Still keep dataIndex to refer to the main object
//   width: 150,
//  render: (_, record) => record.attributes?.survey_feedback || ''
// }

]

const [select, setSelect] = useState({
  selectedRowKeys: [],
  loading: false
});
const [noOfLeads, setNoOfLeads] = useState('');

// Function to handle input change
const handleInputChange = (e) => {
  const value = e.target.value;
 // setNoOfLeads(value);
 const numLeads = parseInt(value, 10);
      const selectedKeys = filteredDataSource
        .slice(0, numLeads)  // Take top `numLeads` rows
        .map(item => item.key);  // Ensure 'key' corresponds to rowKey

        

      setSelect(prevSelect => ({
        ...prevSelect,
        selectedRowKeys: selectedKeys
      }));
};


const { selectedRowKeys, loading } = select;

const rowSelection = {

  selectedRowKeys,
  onChange: (selectedRowKeys) => {
    
    setSelect({
      ...select,
      selectedRowKeys: selectedRowKeys
      
    });
  }
};

// const rowSelection = {
//   selectedRowKeys,
//   onChange: (newSelectedRowKeys) => {
//     
//     setSelect(prevSelect => ({
//       ...prevSelect,
//       selectedRowKeys: newSelectedRowKeys
//     }));
//   }
// };

  
    return(
     
    <div className='callbacktable-main'>
<div className='callbacktable-distribute-select-agent'>
      <Divider variant="dotted" style={{ borderColor: '#7cb305' }}>Distribute Leads</Divider>
        <Flex>
        <Form.Item
        name="no_of_leads"
        style={{ marginLeft: '270px' ,marginTop:20}}
      >
        <Input
          value={noOfLeads}
          placeholder='Enter no of leads'
          onChange={handleInputChange}
          style={{ width: '150px'}}
        />
      </Form.Item>
      <Form.Item
        style={{ marginLeft:'20px',marginTop:20}}
        name="sales-agent"
        label="Sales agent list"
        rules={[
          {
            required: true,
            message: 'Please pick the sales agent ',
          },
         
        ]}
      >

  <Select
    style={{width:'150px',marginLeft:'10px'}}
    showSearch
    placeholder="Select sales agents"
    optionFilterProp="label"
    onChange={onChangeSelect}
    onSearch={onSearch}
    options={salesUsersName}
  />
 </Form.Item>
 
 <Form.Item>
        {/* <Button type="primary" htmlType="submit" className="login-form-button">
          Distribute
        </Button> */}
        <button
        style={{ marginTop:'15px' ,marginLeft:'80px'}}
        class="button-demo" role="button" onClick={handleDistribute}>Distribute</button>
      </Form.Item>
 </Flex></div>
 <div style={{ padding: "10px" }}>
        
        <Space>
          <Select
           value={selectedValue}
            onChange={handleAddField}
            style={{ width: 200 }}
            placeholder="Select a field"
          >
            {fieldOptions.map(option => (
              <Option key={option.value} value={option.value} 
             // disabled={addedFieldNames.includes(option.value)}
              >
                {option.label}
              </Option>
            ))}
          </Select>
        </Space>
        <fieldset> 
          <legend>Search Filters</legend>
        {fields.map((field, index) => (
          
          <Space key={index} style={{ display: 'flex', marginTop: 8 }} align="baseline">
            
            <span>{field.name}</span>
            {field.dataType === 'date' ? (
              <RangePicker
              //  value={field.value[0] && field.value[1] ? [moment(field.value[0]), moment(field.value[1])] : []}
                onChange={(dates, dateStrings) => handleFieldChange(index, 'value', dateStrings)}
              />
            ) : field.dataType === 'number' ? (
              <>
                <Input
                  type="number"
                  value={field.value[0]}
                  onChange={(e) => handleFieldChange(index, 'value', [e.target.value, field.value[1]])}
                  placeholder="Min"
                  style={{ width: '80px', marginRight: '8px' }}
                />
                <Input
                  type="number"
                  value={field.value[1]}
                  onChange={(e) => handleFieldChange(index, 'value', [field.value[0], e.target.value])}
                  placeholder="Max"
                  style={{ width: '80px' }}
                />
              </>
            ) : (
              <> 
                {field.name === 'product_id' && showProductDropdown ? (
                  <Select
                    value={field.value}
                    onChange={(value) => handleFieldChange(index, 'value', value)}
                    style={{ width: 180 }}
                  >
                    {productSupplierOptions.map(option => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                ) : field.name === 'elec_current_supplier' && showElecCurrentSupplierDropdown ? (
                  <Select
                    value={field.value}
                    onChange={(value) => handleFieldChange(index, 'value', value)}
                    style={{ width: 180 }}
                  >
                    {elecCurrentSupplierOptions.map(option => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                ) : field.name === 'gas_current_supplier' && showGasCurrentSupplierDropdown ? (
                  <Select
                    value={field.value}
                    onChange={(value) => handleFieldChange(index, 'value', value)}
                    style={{ width: 180 }}
                  >
                    {gasCurrentSupplierOptions.map(option => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                ) : field.name === 'lead_status_list_id' && showLeadStatusDropdown ? (
                  <Select
                    value={field.value}
                    onChange={(value) => handleFieldChange(index, 'value', value)}
                    style={{ width: 180 }}
                  >
                    {leadStatusOptions.map(option => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                
              ) : field.name === 'sales_status_list_id' && showSalesStatusDropdown ? (
              
                <Select
                value={field.value}
                onChange={(value) => handleFieldChange(index, 'value', value)}
                style={{ width: 180 }}
              >
                {salesStatusOptions.map(option => (
                  <Option key={option.value} value={option.value}>
                    {option.label}
                  </Option>
                ))}
              </Select>
              ): field.name === 'gas_metertype' && showGasMeterTypeDropdown ? (
                  <Select
                    value={field.value}
                    onChange={(value) => handleFieldChange(index, 'value', value)}
                    style={{ width: 180 }}
                  >
                    {gasMeterTypeOptions.map(option => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                ) : field.name === 'elec_metertype' && showElecMeterTypeDropdown ? (
                  <Select
                    value={field.value}
                    onChange={(value) => handleFieldChange(index, 'value', value)}
                    style={{ width: 180 }}
                  >
                    {elecMeterTypeOptions.map(option => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                ) : (
                  <>
                    <Select
                      value={field.operator}
                      onChange={(value) => handleFieldChange(index, 'operator', value)}
                      style={{ width: 120 }}
                    >
                      <Option value="exact">exact</Option>
                      <Option value="like">like</Option>
                      <Option value="unlike">unlike</Option>
                    </Select>
                    <Input
                      value={field.value}
                      onChange={(e) => handleFieldChange(index, 'value', e.target.value)}
                      placeholder="Enter value"
                    />
                  </>
                )}
              </>
            )}
            <DeleteOutlined onClick={() => handleRemoveField(index)} />
          </Space>
        ))}
        </fieldset>

        <Row gutter={16} align="middle" justify="center">
          <Col>
            <Checkbox
              checked={excludeDistributed}
              onChange={(e) => setExcludeDistributed(e.target.checked)}
            >
              Exclude Distributed
            </Checkbox>
          </Col>

          <Col>
            <Button
              icon={<SearchOutlined />}
              type="primary"
              onClick={() => handleSearch(fields)}
              style={{ marginTop: 4 }}
            >
              Search
            </Button>
          </Col>
        </Row>
      </div>
 <div className='callbacktable-distribute-datasource'>
 <div className='record-show' style={{marginBottom:'10px',fontWeight: 'bold'}}>
  {"Total Records "+totalNoOfRecords+"            "}
</div>
        <header className='callbacktable-header'>
          
      
       <Table size="small" rowSelection={rowSelection} loading={loading} columns={columns}
       
       bordered
       
        dataSource={filteredDataSource}
        pagination={{ pageSize: 100 }}
       scroll={{ y: 500 }}
      
       onRow={(record, rowIndex) => {
        return {
        
          onDoubleClick: event => {
            // handleClick(record);
          }, 
         
        };
      }}
      >
       </Table>
       
        </header></div>
    </div>
    );
}

export default DistributedLead;